module.exports = __webpack_public_path__ + "static/img/map7.5be7dc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/divinemap/map7.png
// module id = Mb6T
// module chunks = 1